<template>
    <div class="map-controls">
      <a class="button begin" v-if="nearestdistance <= 100" @click="goNearest">BEGIN</a>
      <div class="exhibit-distance" v-if="nearestdistance <= 100 && $store.state.inzone">You have arrived</div>
      <div v-else-if="$store.state.inzone" class="exhibit-distance">{{ nearestdistance }} feet away from the nearest stop</div>
  </div>
</template>
<script>
export default {
  name: 'mapControls',
  computed: {
    nearestdistance () {
      return this.distance(this.nearest[0].id)
    },
    nearest () {
      let areas = this.$store.state.exhibit_groups.perennial
      let areaNames = Object.keys(areas)
      let areadists = []
      for (let i = 0; i < areaNames.length; i++) {
        let areaId = areas[areaNames[i]]
        areadists.push({'id': areaId, 'name': areaNames[i], 'distance': this.$store.state.distances[areaId]})
      }
      areadists.sort(function (a, b) { return a.distance - b.distance })
      return areadists
    }
  },
  methods: {
    goNearest () {
      this.$router.push('/' + this.nearest[0].name + '/welcome')
    },
    distance (id) {
      console.log('map controls line 32', id)
      return Math.round(this.$store.state.distances[id] * 3.2808)
    }
  }
}
</script>
<style lang="scss" scoped>
  .map-controls {
    position:relative;
  }
</style>
